import { z } from "zod";

export type NumericString = `${number}`;

export type XMLBoolean = 'false' | 'true';

export const idSchema = z.number().int().positive();

export const countryIsoSchema = z.enum(['HU', 'EN']);
export const currencyIsoSchema = z.enum(['HUF']);

export const timestamps = {
  created_at: z.string(),
  updated_at: z.string().nullable(),
};
export const softDelete = {
  deleted_at: z.string().nullable(),
};